import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import NewSessionDialog from "@/components/testsessions/NewSessionDialog";

export const SESSION_STATUS = { draft: "Bozza", in_progress: "In corso", closed: "Chiusa" };
const STATUS_CLS = { draft: "bg-zinc-100 text-zinc-700", in_progress: "bg-blue-100 text-blue-800", closed: "bg-emerald-100 text-emerald-800" };

export const StatusPill = ({ status, testid }) => <span data-testid={testid} className={`text-[11px] px-2 py-0.5 rounded-full ${STATUS_CLS[status] || "bg-zinc-100"}`}>{SESSION_STATUS[status] || status}</span>;
export const KindPill = ({ kind }) => kind === "pilota" ? <span className="text-[11px] px-2 py-0.5 rounded-full bg-amber-100 text-amber-900 border border-amber-200">Pilota</span> : <span className="text-[11px] px-2 py-0.5 rounded-full bg-zinc-900 text-white">Operativa</span>;

export default function TestSessionsTab({ canWrite, groups, batteries }) {
  const nav = useNavigate();
  const [rows, setRows] = useState(null);
  const [open, setOpen] = useState(false);
  const load = () => api.get("/test-sessions").then((r) => setRows(r.data)).catch(() => setRows([]));
  useEffect(() => { load(); }, []);
  const gName = (id) => groups.find((g) => g.id === id)?.name || "—";
  const bName = (id) => batteries.find((b) => b.id === id)?.name || "—";

  return (
    <div className="space-y-4" data-testid="sessions-tab">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <p className="text-sm text-zinc-500">Sessioni collettive: batteria di test su un gruppo, griglia da tablet, import Excel.</p>
        {canWrite && <Button data-testid="new-session-btn" onClick={() => setOpen(true)} className="bg-black hover:bg-zinc-800"><Plus className="w-4 h-4 mr-1" />Nuova sessione</Button>}
      </div>
      <NewSessionDialog open={open} onOpenChange={setOpen} groups={groups} batteries={batteries} onCreated={(s) => nav(`/test/sessione/${s.id}`)} />
      <div className="bg-white border border-zinc-200 rounded-md divide-y divide-zinc-100">
        {rows === null ? <div className="p-6 text-sm text-zinc-500">Caricamento…</div> : rows.length === 0 ? <div className="p-6 text-sm text-zinc-500" data-testid="sessions-empty">Nessuna sessione creata.</div> : rows.map((s) => (
          <button key={s.id} data-testid={`session-row-${s.id}`} onClick={() => nav(`/test/sessione/${s.id}`)} className="w-full text-left px-4 py-3 hover:bg-zinc-50 flex items-center gap-3 flex-wrap">
            <span className="font-mono text-xs text-zinc-500 w-36">{s.code}</span>
            <span className="font-medium">{s.label}</span>
            <KindPill kind={s.kind} />
            <span className="text-xs text-zinc-500">{s.date} · {gName(s.group_id)} · batteria {bName(s.battery_id)}</span>
            <span className="text-xs text-zinc-500 ml-auto">{s.participants_count} atleti · {s.test_ids.length} test · {s.results_count} risultati</span>
            <StatusPill status={s.status} />
          </button>
        ))}
      </div>
    </div>
  );
}
